<script setup>
import { useRoute } from 'vue-router';
import { addContentLogAPI } from '@/api/logServiceApi';
import { gnbMenuLinks } from '@/constants/menuLinks';
import { nangmanCenterContentTypeMap as contentTypeMap } from '@/constants/logContentType';
import { IconNotice, IconEssay, IconEvent, IconFaq, IconCounseling } from '@/components/svg';

const route = useRoute();

const menuTitle = '낭만센터';

const isActive = (menuLink) => {
  // 현재 경로(route.fullPath)가 menuLink로 시작하는지 확인
  return route.path.startsWith(menuLink);
};

const contact = 'info@dangamsoft.com';

const handleMenuClick = (menu) => {
  const contentType = contentTypeMap[menu.link];
  if (contentType) addContentLogAPI(contentType);
};
</script>

<template>
  <div class="gnb-wrap">
    <h3>{{ menuTitle }}</h3>
    <div class="gnb-menu-box">
      <div v-for="(menu, index) in gnbMenuLinks['nangman-center'].subMenu" :key="index">
        <RouterLink
          class="gnb-link"
          :class="{ active: isActive(menu.link) }"
          active-class="active"
          :to="menu.link"
          @click="handleMenuClick(menu)"
        >
          <IconNotice v-if="menu.icon === 'icon-notice'" />
          <IconCounseling v-if="menu.icon === 'icon-counseling'" />
          <IconEvent v-if="menu.icon === 'icon-event'" />
          <IconEssay v-if="menu.icon === 'icon-essay'" />
          <IconFaq v-if="menu.icon === 'icon-faq'" />

          {{ menu.name }}
        </RouterLink>
      </div>
    </div>
    <div class="info-box">
      <div class="txt-tit">고객센터</div>
      <div class="txt-tel">{{ contact }}</div>
      <div class="txt-exp">
        평일 13:00 - 18:00 (주말, 공휴일 휴무)<br />
        답변 시간 이후 접수 건은 운영시간 내 <br />
        순차적으로 답변해 드립니다.
      </div>
    </div>
  </div>
</template>
